import { createDeferred } from "common/utils/deferred";

export interface GfxFileUrlHelper {
  getPostedFileURLByName(path: string): Promise<string | null>;
  getFileStorageBaseURL(): Promise<string | null>;
}

const deferred = createDeferred<GfxFileUrlHelper>();

export const gfxFileUrlHelper = deferred.promise;

export function setGfxFileUrlHelper(helper: GfxFileUrlHelper) {
  deferred.resolve(helper);
}
